import React, { FC } from 'react'
import {
	createStyles,
	makeStyles,
	Paper,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
} from '@material-ui/core'
import { SwapVertOutlined } from '@material-ui/icons'
import AdminObjectsAnalogTableRow from '@root-gipro/modules/AdminPanel/components/AdminObjectsAnalog/components/AdminObjectsAnalogTableRow/AdminObjectsAnalogTableRow'
import Loader from '@root-gipro/shared/Loader/Loader'
import { TAdminObjectAnalog } from '@root-gipro/modules/AdminPanel/interfaces/adminObjectsAnalog'
import { AdminObjectsAnalogSortNames } from '@root-gipro/modules/AdminPanel/constants/constants'

interface IAdminSolutionsTable {
	objectsAnalog: TAdminObjectAnalog[] | null
	
	loadingObjectsAnalogPage: boolean
	onChangeSort: (mode: any) => void
	sort: any
}

const useStyles = makeStyles(() =>
	createStyles({
		root: {
			'& .MuiTableCell-root': {
				padding: '6px 12px',
				lineHeight: '18px',
				height: '61px'
			},
		},
		sortIcon: {
			width: '13px',
			verticalAlign: 'bottom',
			marginLeft: '5px',
			transition: 'transform 0.2s ease, color 0.2s ease',
		},
		sortIconActive: {
			color: '#1976d2', // Подсветка активной сортировки
		},
		sortIconDesc: {
			transform: 'rotate(180deg)', // Переворачиваем, если сортировка по убыванию
		},
		textWithIcon: {
			display: 'inline-flex',
			alignItems: 'center',
			cursor: 'pointer',
			'&:hover $sortIcon': {
				transform: 'scale(1.2)',
				color: '#1976d2',
			},
		},
	})
)

const AdminObjectsAnalogTable: FC<IAdminSolutionsTable> = ( {
	objectsAnalog,
	loadingObjectsAnalogPage,
	onChangeSort,
	sort,
}) => {
	
	const classes = useStyles();
	
	// Функция переключения сортировки
	const toggleSort = (field: AdminObjectsAnalogSortNames) => {
		const newSort = sort === field ? `${field} DESC` : field;
		
		onChangeSort(newSort);
	}

	// Функция для определения активного класса сортировки
	const getSortIconClass = (field: string) => {
		if (sort.startsWith(field)) {
			return `${classes.sortIcon} ${classes.sortIconActive} ${sort.includes('DESC') ? classes.sortIconDesc : ''}`
		}
		
		return classes.sortIcon
	}

	return (
		<TableContainer 
			component={Paper} 
			className={classes.root}
		>
			<div style={{ width: '100%', overflowX: 'auto', height: 'auto' }}>
				<Table 
					size='small' stickyHeader 
					aria-label='admin panel table'
				>
					<TableHead>
						<TableRow>
							<TableCell 
								style={{ width: '10%' }} 
								align='center'
							>
								Действия
							</TableCell>
							
							<TableCell 
								align='center' 
								style={{ width: '15%' }} 
								className={classes.root}
							>
								<span 
									className={classes.textWithIcon} 
									onClick={() => toggleSort(AdminObjectsAnalogSortNames.NUMBER_ID)}
								>
									Номер <SwapVertOutlined className={getSortIconClass(AdminObjectsAnalogSortNames.NUMBER_ID)} />
								</span>
							</TableCell>
							
							<TableCell style={{ width: '45%' }}>
								<span 
									className={classes.textWithIcon} 
									onClick={() => toggleSort(AdminObjectsAnalogSortNames.NAME)}
								>
									Наименование объекта-аналога <SwapVertOutlined className={getSortIconClass(AdminObjectsAnalogSortNames.NAME)} />
								</span>
							</TableCell>
							
							<TableCell 
								style={{ width: '20%' }} 
								align='center'
							>
								<span
									className={classes.textWithIcon}
									onClick={() => toggleSort(AdminObjectsAnalogSortNames.TH_NAME)}
								>
									Название ТХ <SwapVertOutlined className={getSortIconClass(AdminObjectsAnalogSortNames.TH_NAME)} />
								</span>
							</TableCell>
							
							<TableCell 
								style={{ width: '10%' }} 
								align='center'
							>
								Количество
							</TableCell>

							<TableCell
								style={{ width: '10%' }}
								align='center'
							>
								Единица измерения
							</TableCell>

							<TableCell
								style={{ width: '20%' }}
								align='center'
							>
								Итого по главам 1-12, тыс. руб. с НДС
							</TableCell>
						</TableRow>
					</TableHead>
					
					<TableBody>
						{loadingObjectsAnalogPage ? (
							<tr>
								<td 
									colSpan={100} 
									style={{ textAlign: 'center', padding: '10px' }}
								>
									<Loader />
								</td>
							</tr>
						) : objectsAnalog?.length ? (
							objectsAnalog.map((objectAnalog) => {
								
								return (
									<AdminObjectsAnalogTableRow
										key={objectAnalog.id}
										objectAnalog={objectAnalog}
									/>
								)
							})
						) : (
							<tr>
								<td 
									colSpan={100} 
									style={{ textAlign: 'center', padding: '10px' }}
								>
									Нет данных для отображения
								</td>
							</tr>
						)}
					</TableBody>
				</Table>
			</div>
    </TableContainer>
	)
}

export default AdminObjectsAnalogTable
